import type { DLRPolicy, DLRPolicyInput, EntityStatus } from "@/app/master";
import type { Errors } from "@/app/useDraft";

/** 回执策略表单，百分比在界面输入，接口使用整数基点。 */
export interface DLRPolicyDraft {
  name: string;
  timeout_sec: string;
  failure_percent: string;
  status: EntityStatus;
}

/** 新建默认保持真实结果，超时默认72小时。 */
export function dlrPolicyDraft(row?: DLRPolicy): DLRPolicyDraft {
  return {
    name: row?.name ?? "",
    timeout_sec: String(row?.timeout_sec ?? 259200),
    failure_percent: String((row?.failure_success_bps ?? 0) / 100),
    status: row?.status ?? "active",
  };
}

/** 严格校验秒数及百分比，不接受空值、非有限数或超出两位的小数。 */
export function dlrPolicyInput(d: DLRPolicyDraft): { body?: DLRPolicyInput; errors: Errors<DLRPolicyDraft> } {
  const errors: Errors<DLRPolicyDraft> = {};
  const sec = Number(d.timeout_sec);
  const percent = Number(d.failure_percent);
  if (!d.name.trim()) errors.name = "填写策略名称。";
  if (!/^\d+$/.test(d.timeout_sec) || !Number.isSafeInteger(sec) || sec < 1 || sec > 259200) errors.timeout_sec = "填写1–259200的整数秒数。";
  if (!/^\d+(?:\.\d{1,2})?$/.test(d.failure_percent) || !Number.isFinite(percent) || percent < 0 || percent > 100) errors.failure_percent = "填写0–100的百分比，最多两位小数。";
  if (Object.keys(errors).length) return { errors };
  return { errors, body: { name: d.name.trim(), timeout_sec: sec, failure_success_bps: Math.round(percent * 100), status: d.status } };
}
